import { render, staticRenderFns } from "./BudgetPrefixesModal.vue?vue&type=template&id=1bdc2277&scoped=true&"
import script from "./BudgetPrefixesModal.vue?vue&type=script&lang=js&"
export * from "./BudgetPrefixesModal.vue?vue&type=script&lang=js&"
import style0 from "./BudgetPrefixesModal.vue?vue&type=style&index=0&id=1bdc2277&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc2277",
  null
  
)

export default component.exports